<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>

<script>
import Top from '@/views/Top.vue'
import Top4Member from '@/views/Top4Member.vue'
import Top4BeautyOEM from '@/views/Top4BeautyOEM.vue'
import firebase from 'firebase/app'

export default {
  name: 'TopCommon',
  components: {
    Top,
    Top4Member,
    Top4BeautyOEM
  },
  data () {
    return {
      currentComponent: Top
    }
  },
  created () {
    const app = this
    if (process.env.VUE_APP_SITE_FLAG == 'o') {
      this.currentComponent = 'Top4BeautyOEM'
    } else {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.currentComponent = 'Top4Member'
        } else {
          this.currentComponent = 'Top'
        }
      })
    }
  }
}
</script>
